class DropdownButton {
    constructor() {
        this.dropdownOpenClass = "dropdown-button--open";
    }

    init() {
        this.apply();

        document.addEventListener("click", (event) => {
            for(const ddButton of document.querySelectorAll(".dropdown-button")) {
                if (!event.target.closest(".dropdown-button")) {
                    ddButton.classList.remove(this.dropdownOpenClass);
                }
            }
        });
    }

    apply() {
        for(const ddButton of document.querySelectorAll(".dropdown-button")) {

            if(ddButton.getAttribute("data-dropdown-button")) {
                continue;
            }

            const button = ddButton.querySelector(".button");
            ddButton.setAttribute("data-dropdown-button", true);

            button.addEventListener("click", (e) => {
                e.preventDefault();

                this.closeAll(ddButton);

                if(ddButton.classList.contains(this.dropdownOpenClass)) {
                    ddButton.classList.remove(this.dropdownOpenClass);
                } else {
                    ddButton.classList.add(this.dropdownOpenClass);
                }
            });
        }
    }

    closeAll(excludeElm) {
        for(const ddButton of document.querySelectorAll(".dropdown-button")) {
            if (ddButton !== excludeElm) {
                ddButton.classList.remove(this.dropdownOpenClass);
            }
        }
    }
}

const dropdownButton = new DropdownButton();

export default dropdownButton;
